import ReportAdditionalNotesModal from './ReportAdditionalNotesModal.vue';

export default ReportAdditionalNotesModal;
